import * as yup from "yup";
import {stringRequired, url} from "../../../../../../yup/defaultValudations";

export const schema = yup.object().shape({
  name: stringRequired(),
  url: url(),
});
